import {
  FieldDesignChangeStatus,
  Permission,
  SharePointParentFolder,
} from 'shared'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'
import { FieldDesignChange } from '../../../FDCTrackerContext/types'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'
import { useClosedDisabledMessage } from '../../../../../../../../../../components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useCustomRowOptions(): CustomRowActionOptions<FieldDesignChange>[] {
  const {
    mutations: { revert },
    fieldDesignChanges,
    repair,
  } = useFDCTrackerContext()
  const lock = useLockRowActionButton<FieldDesignChange>({
    refetch: fieldDesignChanges?.refetch,
    parent: SharePointParentFolder.FieldDesignChanges,
    hidden: ({ statusId }) => statusId !== FieldDesignChangeStatus.Unlocked.id,
  })
  const unlock = useUnlockRowActionButton<FieldDesignChange>({
    refetch: fieldDesignChanges?.refetch,
    parent: SharePointParentFolder.FieldDesignChanges,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== FieldDesignChangeStatus.Closed.id,
  })
  return [
    {
      text: 'Revert',
      permission: Permission.RevertFieldDesignChange,
      onClick: (record) => revert.toggle(record),
      disabled: useClosedDisabledMessage(
        'reverted',
        FieldDesignChangeStatus.Closed
      ),
      hidden: ({ statusId, deleted }) =>
        deleted ||
        [
          FieldDesignChangeStatus.Draft.id,
          FieldDesignChangeStatus.PendingLevelConcurrences.id,
        ].some((id) => id === statusId),
    },
    unlock,
    lock,
    repair,
  ]
}
